export default "__VITE_ASSET__28cca79c__"